import {
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import SubmitOhiDescription from '../../components/FormDescriptions/SubmitOhiDescription';
import { blankSchema } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['supplemental--ohi-submit-title'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    ...descriptionUI(SubmitOhiDescription),
  },
  schema: blankSchema,
};
